import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getAvailableFacetNameAttributesList, getSelectedFacets } from 'selectors/algolia2/facets'
import {
  getAllSelectedFacets,
  getSelectedCategoryFacetLength,
  getAllCategoryFacets,
  getSelectedCategoryFacet,
  getSelectedCategoryRecCarousel,
} from '../selectors/facets'

const mapStateToProps = createStructuredSelector({
  facetNameAttributesList: (state, ownProps) =>
    getAvailableFacetNameAttributesList(ownProps.facetName)(state),
  categoryList: (state, ownProps) => getAvailableFacetNameAttributesList('category')(state),
  allSelectedFacets: getAllSelectedFacets,
  selectedFacets: getSelectedFacets,
  isCategorySelected: getSelectedCategoryFacetLength,
  categoryFacet: getAllCategoryFacets,
  selectedCategoryFacet: getSelectedCategoryFacet,
  selectedCategoryRecCarousel: getSelectedCategoryRecCarousel,
})

export type ConnectorProps = {
  facetNameAttributesList: Array<string>
  categoryList: Array<string>
  selectedFacets: Record<string, any>
  allSelectedFacets: Array<Record<string, any>>
  isCategorySelected: number
  categoryFacet: Array<string>
  selectedCategoryFacet: string
  selectedCategoryRecCarousel: string
}

export default connect(mapStateToProps)
